import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor(
        private primengConfig: PrimeNGConfig,
        private logger: NGXLogger,
        private router: Router,
        private messageService: MessageService
    ) { }

    ngOnInit() {
        //this.logger.info("*ONINIT @ AppComponent");
        this.primengConfig.ripple = true;
        this.checkAuth0ErrorParams();
    }

    private checkAuth0ErrorParams(): void {
        // Controllo immediato usando window.location per catturare i params
        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error');
        const errorDescription = urlParams.get('error_description');

       /*  console.log('[APP COMPONENT] Checking error params:', { error, errorDescription, fullUrl: window.location.href });
        this.logger.info('AppComponent - Checking Auth0 error params', { error, errorDescription }); */

        if (error === 'unauthorized' && errorDescription && errorDescription.includes('user is blocked')) {
            const errorMessage = 'Accesso negato: il tuo account è stato bloccato. Contatta l\'amministratore per maggiori informazioni.';

            /* console.error('[APP COMPONENT - AUTH ERROR] Utente bloccato da Auth0:', {
                error: error,
                errorDescription: decodeURIComponent(errorDescription),
                state: urlParams.get('state'),
                fullUrl: window.location.href
            }); */

          /*   this.logger.error('AppComponent - Utente bloccato da Auth0', {
                error: error,
                errorDescription: decodeURIComponent(errorDescription),
                state: urlParams.get('state')
            }); */

            // Mostra messaggio di errore dopo un breve delay per assicurarsi che il DOM sia pronto
            setTimeout(() => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Accesso Negato',
                    detail: errorMessage,
                    life: 10000,
                    closable: true
                });
               // console.log('[APP COMPONENT] Toast message added');
            }, 1000);

            // Pulisci i parametri dalla URL
            setTimeout(() => {
                this.router.navigate([], {
                    queryParams: {},
                    replaceUrl: true
                }).then(() => {
                    //console.log('[APP COMPONENT] URL cleaned after error');
                });
            }, 2000);
        }
    }
}
